import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { EMPLOYEE_CONFIG } from "../../../../../../constants/employeeConfig";
import { fetchAllReferenceData } from "../../../../../../utils/employee/fetchAllReferenceData";
import { buildTemplateWorksheet } from "../../../../../../utils/employee/buildWorksheet";

// =============================================================================
// PREPEND FIELDS
// Bulk update template needs EmployeeId and EmployeeName as the first two
// columns so the user knows which employee row they are updating.
// =============================================================================
const BULK_UPDATE_PREPEND_FIELDS = [
  {
    key:          "employeeId",
    label:        "EmployeeId",
    width:        25,
    sampleValue:  "<EMP1234>",
    dropdownList: null,
  },
  {
    key:          "employeeName",
    label:        "EmployeeName",
    width:        30,
    sampleValue:  "<DELA CRUZ, JUAN>",
    dropdownList: null,
  },
];

// =============================================================================
// GENERATE DOWNLOAD FOR BULK UPDATE TEMPLATE
// Generates a single-sheet Excel template used for bulk updating employee
// information. Only contains the EmployeeInformation section fields.
//
// Date fields and employmentDuration are excluded — those are managed
// individually per employee, not via bulk update.
// Fields excluded are marked with excludeFromBulkUpdate: true in the config.
//
// Adding a new field:  add it to employeeFields.js — done, no changes here
// Excluding a field from bulk update: add excludeFromBulkUpdate: true in config
//
// -use for  ---Download Employee Information Template---
//
// =============================================================================
export const generateDownloadForBulkUpdateTemplate = async () => {
  const workbook = new ExcelJS.Workbook();

  // Fetch all reference data in one call
  const refs = await fetchAllReferenceData();

  // Filter out fields marked as excluded from bulk update
  // Everything else — feature flags, dropdowns, column letters — handled automatically
  const bulkUpdateSection = {
    ...EMPLOYEE_CONFIG.employeeInformation,
    fields: EMPLOYEE_CONFIG.employeeInformation.fields.filter(
      (f) => !f.excludeFromBulkUpdate
    ),
  };

  // Single sheet — EmployeeInformation only
  await buildTemplateWorksheet(
    workbook,
    "EmployeeInformation",
    bulkUpdateSection,
    refs,
    { prependFields: BULK_UPDATE_PREPEND_FIELDS }
  );

  // Finalize and trigger download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Employee_Information_Template.xlsx");
};